export default {
    'modify-amount-received': 'تعديل المبلغ المستلم'
}